export const createPrincipalClientKey = (id?: string) => {
  if (id) return id;
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `principal-${Math.random().toString(36).slice(2)}`;
};
